export default "__VITE_ASSET__e69f8817__"